// extracted by mini-css-extract-plugin
export default {"screenLoader":"screenLoader_screenLoader__djdDd","spinner":"screenLoader_spinner__4I2DC"};